var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"colorset-mini-view"},_vm._l((_vm.colorset.array),function(item,index){return _c('li',{key:index,staticClass:"col",style:({
    backgroundColor:_vm.itemCssColor(item),
    width: _vm.itemCssWidth(index)
  })})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d5569f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorsetMiniView.vue
// module id = null
// module chunks = 